
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/player",
      function () {
        return require("private-next-pages/player.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/player"])
      });
    }
  